import request from '@/utils/request'
const shopSkus = async (params) => {
  params.rows = 100;
  params.page = 0;
  // debugger
  let result = await request({
    url: '/shop/skus/search',
    params,
    method: 'get'
  })
  while (result.count > result.products.length) {
    // debugger;
    params.page = params.page != null && params.page != undefined ? params.page : 0;
    params.page = params.page + 1;
    let temp = await request({
      url: '/shop/skus/search',
      params,
      method: 'get'
    });
    result.products.push(...temp.products);
  }
  return result;
}

const shopSkusDetail = (sku) => {
  return request({
    url: `/shop/skus/${sku}`,
    method: 'get'
  })
}

const shopSkusList = (params) => {
  return request({
    url: '/shop/skus',
    params,
    method: 'get'
  })
}

const getSimilars = (sku) => {
  return request({
    url: `/shop/skus/${sku}/similars`,
    method: 'get'
  })
}

const getStock = (params) => {
  return request({
    url: '/shop/skus/stock',
    data: params,
    method: 'post'
  })
}
const getGoodsStock = (sku) => {
  return request({
    url: `/shop/skus/${sku}/stock`,
    method: 'get'
  })
}
export {
  shopSkus, // 搜索商品
  shopSkusDetail, // 商品详情
  shopSkusList, // 批量信息查询
  getSimilars, // 查询类似商品
  getStock, // 查询库存
  getGoodsStock // 获取商品库存数量
}
